import { css } from "@emotion/react";
import { useForm, FormProvider } from "react-hook-form";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";
import { PasswordFormField, UsernameFormField } from "@/components/molecules";
import { useIsSpMode } from "@/hooks";
import {
  loginIDValidation,
  requiredValidation,
} from "@/components/validations";
import config from "@/libs/config";

type FormValues = {
  username: string;
  password: string;
};

type Props = {
  onSubmit?: ({ username, password }: FormValues) => void;
};

export const SignInFormWithId = (props: Props) => {
  const isSpMode = useIsSpMode();
  const displayMessage = config.USING_BIZSOL && config.IS_SHIKOKUBANK;
  const bankNickName = config.BANK_NICKNAME;

  const methods = useForm<FormValues>({
    reValidateMode: "onBlur",
    defaultValues: {
      username: "",
      password: "",
    },
  });

  return (
    <div css={container}>
      <div css={!isSpMode ? box : spModeBox}>
        {displayMessage && (
          <div css={bizsolWrapper}>
            <Font variant="s" component="p">
              {bankNickName} Mikatanoサービスを共通IDで利用できます。
              <br />
              管理者より共有されたユーザーID/パスワードでログインしてください。
            </Font>
          </div>
        )}
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(props.onSubmit)} css={form}>
            <div css={!isSpMode ? inputList : spModeInputList}>
              <div css={listItem}>
                <UsernameFormField
                  name="username"
                  validate={loginIDValidation}
                />
              </div>
              <div css={listItem}>
                <PasswordFormField
                  name="password"
                  registerOptions={{
                    validate: requiredValidation,
                  }}
                />
              </div>
            </div>
            <div css={buttonWrapper}>
              <Button type="submit" disabled={methods.formState.isSubmitting}>
                ログイン
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  minHeight: "210px",
  padding: "18px 32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const spModeBox = css({
  width: "640px",
  minHeight: "210px",
  padding: "15px 17px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const form = css({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  paddingTop: "16px",
  paddingBottom: "32px",
});

const inputList = css({
  flex: 1,
});

const spModeInputList = css({
  flex: 1,
});

const listItem = css({
  marginBottom: "25px",
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "8px",
});

const bizsolWrapper = css({
  padding: "25px 35px 25px 35px",
  backgroundColor: `${color.gray50}`,
  textAlign: "center",
});

const link = css({
  color: `${color.link}`,
});
